import BillsCategoryInfo from '../../../bills/components/BillsCategoryInfo';

export default function BillsCategoryInfoScreen() {
    return <BillsCategoryInfo />;
}
